import { render, staticRenderFns } from "./PriceScrollIndicator.vue?vue&type=template&id=601c0d5e&scoped=true&"
import script from "./PriceScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./PriceScrollIndicator.vue?vue&type=script&lang=js&"
import style0 from "./PriceScrollIndicator.vue?vue&type=style&index=0&id=601c0d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c0d5e",
  null
  
)

export default component.exports